import { Box } from 'rebass/styled-components'
import styled from 'styled-components'

const Card = styled(Box)<{ width?: string; padding?: string; border?: string; $borderRadius?: string }>`
  width: ${({ width }) => width ?? '100%'};
  padding: ${({ padding }) => padding ?? '1rem'};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? '8px'};
  border: ${({ border }) => border};
  overflow-x: hidden;
`
export default Card

export const LightCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  background-color: ${({ theme }) => theme.cardSecondary};
`

export const LightGreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.deprecated_bg2};
`

export const GreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.deprecated_bg3};
`

export const DarkGreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.deprecated_bg2};
`

export const DarkCard = styled(Card)`
  background-color: ${({ theme }) => theme.cardPrimary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
`

export const OutlineCard = styled(Card)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
`

export const YellowCard = styled(Card)`
  background-color: rgba(243, 132, 30, 0.05);
  color: ${({ theme }) => theme.deprecated_yellow3};
  font-weight: 500;
`

export const BlueCard = styled(Card)`
  background-color: ${({ theme }) => theme.deprecated_primary5};
  color: ${({ theme }) => theme.deprecated_blue2};
  border-radius: 12px;
`
